import { ApolloError, useQuery } from '@apollo/client';
import OvertimeProjectEmployeesQuery from './graphql/OvertimeProjectEmployees.query';
import { Employee } from './graphql/__generated__/Employee.fragment';

interface UseProjectEmployeesResponse {
  employees: Employee[];
  loading: boolean;
  error?: ApolloError;
}

export default function useProjectEmployees(projectId: string): UseProjectEmployeesResponse {
  const { data, loading, error } = useQuery(OvertimeProjectEmployeesQuery, {
    variables: {
      projectId,
    },
  });

  return {
    employees: data?.employeesForProject ?? [],
    loading,
    error,
  };
}
